module.exports = __webpack_public_path__ + "components/leaflet/static/placeholder-icon-746b3148347bd3d64760536e5b88ec68.svg";